import _ from 'lodash';

export const EMPTY_PAGINATION_OBJECT = {
  pageSize: 10,
  offset: 0,
  elementsCount: 0
};

export const PAGINATION = {
  BOOKING_LIST: 'bookingList',
  BOOKING_SET_LIST: 'bookingSetList',
  INVOICE_REPORTING_LIST: 'invoiceReportingList',
  INTEGRATIONS_STATUS_LIST: 'integrationsStatusList',
  USERS_LIST: 'usersList',
  AVAILABILITY: 'availability',
  PAYMENTS_LIST: 'paymentsList',
  NOTES_LIST: 'notesList',
  MEMBER_LIST: 'memberList',
  ONE_OFF_CHARGE_REASONS_LIST: 'oneOffChargeReasonsList',
  CREDIT_NOTES_LIST: 'creditNotesList',
  BOOKING_TRACKER: 'bookingTracker'
};

export const selectPagination = (state, namespace) => {
  return _.get(state, `pagination.${namespace}`, EMPTY_PAGINATION_OBJECT);
};

export const SET_PAGINATION_ELEMENTS_COUNT =
  'pagination/SET_PAGINATION_ELEMENTS_COUNT';
export const setPaginationElementsCount = ({elementsCount, namespace}) => ({
  type: SET_PAGINATION_ELEMENTS_COUNT,
  payload: {
    elementsCount,
    namespace
  }
});

export const SET_PAGINATION = 'pagination/SET_PAGINATION';
export const setPagination = ({pageSize, offset, namespace}) => ({
  type: SET_PAGINATION,
  payload: {
    pageSize,
    offset,
    namespace
  }
});

export const SET_CURSOR_PAGINATION = 'pagination/SET_CURSOR_PAGINATION';
export const setCursorPagination = ({pageSize, namespace, cursor}) => ({
  type: SET_CURSOR_PAGINATION,
  payload: {
    pageSize,
    namespace,
    cursor
  }
});

export const SET_PAGINATION_HAS_PREVIOUS_AND_HAS_NEXT =
  'pagination/SET_PAGINATION_HAS_PREVIOUS_AND_HAS_NEXT';
export const setPaginationHasPreviousAndHasNext = ({
  namespace,
  hasPrevious,
  hasNext
}) => ({
  type: SET_PAGINATION_HAS_PREVIOUS_AND_HAS_NEXT,
  payload: {
    namespace,
    hasPrevious,
    hasNext
  }
});

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGINATION:
      return {
        ...state,
        [action.payload.namespace]: {
          pageSize: action.payload.pageSize,
          offset: action.payload.offset
        }
      };
    case SET_PAGINATION_ELEMENTS_COUNT:
      return {
        ...state,
        [action.payload.namespace]: {
          ...state[action.payload.namespace],
          elementsCount: action.payload.elementsCount
        }
      };
    case SET_CURSOR_PAGINATION:
      return {
        ...state,
        [action.payload.namespace]: {
          ...state[action.payload.namespace],
          pageSize: action.payload.pageSize,
          cursor: action.payload.cursor
        }
      };
    case SET_PAGINATION_HAS_PREVIOUS_AND_HAS_NEXT:
      return {
        ...state,
        [action.payload.namespace]: {
          ...state[action.payload.namespace],
          hasPrevious: action.payload.hasPrevious,
          hasNext: action.payload.hasNext
        }
      };

    default:
      return state;
  }
};

export default reducer;
